import './PhoneIntegrationRow.scss'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { useGetMeQuery } from '../../../../store/user/user'
import React, { useMemo, useState } from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { MissingScopeAction } from '../../../../components/ScopedBlock/models'
import { Button } from '../../../../components/Button/Button'
import { ScopedBlock } from '../../../../components/ScopedBlock/ScopedBlock'
import { PhoneSettingsModal } from './PhoneSettingsModal'
import { ClaimPhoneNumberPage } from '../../../Integration/Connectors/ModalIntegrationConnectors/Phone/models'
import { ClaimPhoneNumberModal } from '../../../Integration/Connectors/ModalIntegrationConnectors/Phone/ClaimPhoneNumberModal'

export type PhoneIntegrationRowProps = {}

export const PhoneIntegrationRow: React.FC<PhoneIntegrationRowProps> = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const phoneIntegrations = useMemo(() => {
    return userData?.integrations?.filter((i) => i.serviceId === IntegrationServiceId.PHONE)
  }, [userData])
  const [showSettingsModal, setShowSettingsModal] = useState(false)
  const [showClaimPhoneNumberModal, setShowClaimPhoneNumberModal] = useState(false)
  const [initialPage, setInitialPage] = useState<ClaimPhoneNumberPage | undefined>(undefined)
  const [initialPhoneNumber, setInitialPhoneNumber] = useState<string | undefined>(undefined)

  const handleShowClaimPhoneNumberModal = (page: ClaimPhoneNumberPage | undefined = undefined, phoneNumber: string | undefined = undefined) => {
    setInitialPage(page)
    setInitialPhoneNumber(phoneNumber)
    setShowSettingsModal(false)
    setShowClaimPhoneNumberModal(true)
  }

  const handleHideClaimPhoneNumberModal = () => {
    setShowClaimPhoneNumberModal(false)
    setInitialPage(undefined)
    setInitialPhoneNumber(undefined)
  }

  const handleShowSettingsModal = async () => {
    setShowClaimPhoneNumberModal(false)
    setShowSettingsModal(true)
  }

  const handleHideSettings = () => {
    setShowSettingsModal(false)
  }

  const activatedPhoneNumberCount = phoneIntegrations?.filter((i) => i.state === 'live').length
  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      {showClaimPhoneNumberModal && userData && (
        <ClaimPhoneNumberModal show={showClaimPhoneNumberModal} onHide={handleHideClaimPhoneNumberModal} page={initialPage} phoneNumber={initialPhoneNumber} />
      )}
      {showSettingsModal && userData && (
        <PhoneSettingsModal
          show={showSettingsModal}
          onHide={handleHideSettings}
          accountId={accountId}
          userId={userData.id}
          phoneIntegrations={phoneIntegrations}
          showClaimPhoneNumberModal={handleShowClaimPhoneNumberModal}
        />
      )}
      <Row className='d-flex justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded phone-integration-icon-wrapper'>
              <i className='bi bi-telephone-fill' />
            </div>
            <div>
              <h6>Phone</h6>
              <div>
                Link your phone numbers. If you would like to learn more, you can read our full{' '}
                <a
                  target='_blank'
                  href='https://help.zocks.io/en/articles/9969795-how-to-connect-zocks-to-your-phone-calls'
                  rel='noreferrer'
                  className='button-link-medium zocks-text-gray-900'
                >
                  Help&nbsp;article.
                </a>
              </div>
            </div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-3 align-items-start'>
            <div className='d-flex gap-3'>
              <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:read', superScope: ['integration:admin'] }}>
                <Button variant='primaryGhost' onClick={handleShowSettingsModal}>
                  <i className='bi bi-gear' />
                </Button>
              </ScopedBlock>
            </div>
            <div className='connect-button-container'>
              <ScopedBlock
                scope={{
                  scope: 'integration:connect',
                  superScope: ['integration:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <ScopedBlock
                  scope={{
                    scope: 'room_session:start',
                    superScope: ['room_session:admin', 'room:admin'],
                  }}
                  missingScopeAction={MissingScopeAction.DISABLE}
                >
                  <Button variant='primary' onClick={(event) => handleShowClaimPhoneNumberModal()}>
                    {!!phoneIntegrations?.length ? 'Link more phone numbers' : 'Link your phone number'}
                  </Button>
                </ScopedBlock>
              </ScopedBlock>
              {!!activatedPhoneNumberCount && (
                <div className='pt-2 d-flex justify-content-end zocks-text-success'>
                  <i className='bi bi-check' />
                  {activatedPhoneNumberCount} Number{activatedPhoneNumberCount > 1 ? 's' : ''} Activated
                </div>
              )}
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
